<template>
  <svg
    class="app-ico"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g :stroke="stroke" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <template v-if="name === 'home'">
        <path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z" />
      </template>
      <template v-else-if="name === 'search'">
        <circle cx="11" cy="11" r="6.5" />
        <path d="M16.5 16.5L20 20" />
      </template>
      <template v-else-if="name === 'building'">
        <path d="M4 20V7l8-3 8 3v13" />
        <path d="M9 20v-5h6v5" />
        <path d="M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" />
      </template>
      <template v-else-if="name === 'user'">
        <circle cx="12" cy="8" r="3.2" />
        <path d="M5 20c1.5-3.2 4-5 7-5s5.5 1.8 7 5" />
      </template>
      <template v-else-if="name === 'inbox'">
        <path d="M4 8l2-4h12l2 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8z" />
        <path d="M4 8h16M9 13h6" />
      </template>
      <template v-else-if="name === 'users'">
        <path d="M16 20v-1.5c0-2-1.8-3.5-4-3.5H7c-2.2 0-4 1.5-4 3.5V20" />
        <circle cx="9.5" cy="7" r="3" />
        <path d="M21 20v-1.2c0-1.7-1.2-3-2.8-3.3" />
        <path d="M17.2 7.2a2.5 2.5 0 0 1 0 4.6" />
      </template>
      <template v-else-if="name === 'badge'">
        <path d="M12 3l2.2 4.4 4.8.7-3.5 3.4.8 4.8L12 14.5 7.7 16.3l.8-4.8L5 8.1l4.8-.7L12 3z" />
      </template>
      <template v-else-if="name === 'chevron'">
        <path d="M9 6l6 6-6 6" />
      </template>
      <template v-else-if="name === 'back'">
        <path d="M15 6l-6 6 6 6" />
      </template>
      <template v-else-if="name === 'center'">
        <path d="M3 20h18M5 20V8l7-4 7 4v12M9 12h6M9 16h6" />
      </template>
      <template v-else-if="name === 'care'">
        <path d="M12 20s-7-4.2-7-9.2A3.8 3.8 0 0 1 12 8a3.8 3.8 0 0 1 7 2.8C19 15.8 12 20 12 20z" />
      </template>
      <template v-else-if="name === 'refresh'">
        <path d="M4.5 12a7.5 7.5 0 0 1 12.7-5.4" />
        <path d="M17.5 4.5v3.2h-3.2" />
        <path d="M19.5 12a7.5 7.5 0 0 1-12.7 5.4" />
        <path d="M6.5 19.5v-3.2h3.2" />
      </template>
      <template v-else-if="name === 'calendar'">
        <rect x="4" y="5" width="16" height="15" rx="2" />
        <path d="M8 3.5v3M16 3.5v3M4 10h16" />
        <path d="M9 14h.01M12 14h.01M15 14h.01M9 17h.01M12 17h.01" />
      </template>
      <template v-else-if="name === 'plus'">
        <path d="M12 5v14M5 12h14" />
      </template>
      <template v-else-if="name === 'clock'">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v4.5l3 1.5" />
      </template>
      <template v-else-if="name === 'edit'">
        <path d="M4 20h4.5L19 9.5 14.5 5 4 15.5V20z" />
        <path d="M12.5 7l4.5 4.5" />
      </template>
      <template v-else-if="name === 'trash'">
        <path d="M5 7h14M10 7V5h4v2M8 7v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7" />
        <path d="M10 11v5M14 11v5" />
      </template>
      <template v-else-if="name === 'note'">
        <path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
        <path d="M14 3v5h5M8 13h8M8 17h5" />
      </template>
      <template v-else-if="name === 'close'">
        <path d="M6 6l12 12M18 6L6 18" />
      </template>
      <template v-else-if="name === 'check'">
        <path d="M5 12.5l4.5 4.5L19 7" />
      </template>
      <template v-else-if="name === 'bell'">
        <path d="M12 4a5 5 0 0 1 5 5v2.5c0 .8.3 1.6.8 2.2L19 15H5l1.2-1.3c.5-.6.8-1.4.8-2.2V9a5 5 0 0 1 5-5z" />
        <path d="M10 18a2 2 0 0 0 4 0" />
      </template>
      <template v-else-if="name === 'menu'">
        <path d="M5 7h14M5 12h14M5 17h14" />
      </template>
      <template v-else-if="name === 'chat'">
        <path d="M5 6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5v7A2.5 2.5 0 0 1 16.5 16H11l-3.5 3v-3H7.5A2.5 2.5 0 0 1 5 13.5v-7z" />
        <path d="M8.5 9h7M8.5 12h4.5" />
      </template>
      <template v-else-if="name === 'rfid'">
        <rect x="5" y="7" width="14" height="10" rx="2" />
        <path d="M8 12h.01M11 10.5v3M14 9.5v5" />
      </template>
      <template v-else-if="name === 'download'">
        <path d="M12 4v10" />
        <path d="M8 10l4 4 4-4" />
        <path d="M5 19h14" />
      </template>
      <template v-else-if="name === 'warn'">
        <path d="M12 4l8.5 15H3.5L12 4z" />
        <path d="M12 10v4" />
        <path d="M12 16.6v.2" />
      </template>
      <template v-else-if="name === 'help'">
        <circle cx="12" cy="12" r="8.2" />
        <path d="M9.6 9.3a2.5 2.5 0 1 1 3.3 2.4c-.7.4-1.1 1-1.1 1.8" />
        <path d="M12 17.1h.01" />
      </template>
      <template v-else-if="name === 'camera'">
        <path d="M4 8.5h3l1.4-2.2h7.2L17 8.5h3v10.2a1.3 1.3 0 0 1-1.3 1.3H5.3A1.3 1.3 0 0 1 4 18.7V8.5z" />
        <circle cx="12" cy="13.6" r="3.2" />
      </template>
      <template v-else-if="name === 'receipt'">
        <path d="M7 3.5h10v17l-1.6-1-1.6 1-1.6-1-1.6 1-1.6-1-1.6 1V3.5z" />
        <path d="M9.2 8h5.6M9.2 11.2h5.6M9.2 14.4h3.6" />
      </template>
      <template v-else-if="name === 'ledger'">
        <path d="M5 4.5h12a2 2 0 0 1 2 2v13H7a2 2 0 0 1-2-2v-13z" />
        <path d="M7 4.5v13" />
        <path d="M10.5 9h5M10.5 12.5h5M10.5 16h3.2" />
      </template>
    </g>
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    name:
      | 'home'
      | 'search'
      | 'building'
      | 'user'
      | 'inbox'
      | 'users'
      | 'badge'
      | 'chevron'
      | 'back'
      | 'center'
      | 'care'
      | 'refresh'
      | 'calendar'
      | 'plus'
      | 'clock'
      | 'edit'
      | 'trash'
      | 'note'
      | 'close'
      | 'check'
      | 'bell'
      | 'menu'
      | 'chat'
      | 'rfid'
      | 'download'
      | 'warn'
      | 'help'
      | 'camera'
      | 'receipt'
      | 'ledger'
    size?: number
    stroke?: string
  }>(),
  { size: 22, stroke: 'currentColor' }
)
</script>
